import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.95409 12.7028L1.86575 15.8527C1.67432 16.0479 1.36086 16.051 1.16562 15.8596L1.16215 15.8561C0.966325 15.6603 0.964761 15.3433 1.15864 15.1455L4.24711 11.9955L0.75 8.49711L1.32652 7.85727C2.39181 6.67498 3.90857 6 5.5 6H7.25L9 4.25V3.49264C9 2.69699 9.31607 1.93393 9.87868 1.37132L10.5 0.75L16.25 6.5L15.6287 7.12132C15.0661 7.68393 14.303 8 13.5074 8H12.75L11 9.75V11.5C11 13.0913 10.3246 14.6079 9.14176 15.6724L8.5 16.25L4.95409 12.7028ZM10 4.75L7.75 7H5.45256C4.21535 7 3.04205 7.54954 2.25 8.5L8.5 14.75C9.45046 13.958 10 12.7847 10 11.5474V9.25L12.25 7H13.5429C13.9956 7 14.4299 6.82014 14.75 6.5L10.5 2.25C10.1799 2.57014 10 3.00435 10 3.45711V4.75Z"
      fill="#000624"
    />
  </svg>
);

const WixSaveTemplateIcon = (props) => <Icon component={svg} {...props} />;

export default WixSaveTemplateIcon;
